import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Table, Pagination, Modal } from 'antd'

import { getAllBrandFunctions, createBrandFunction } from '../../../../../data/redux/brand_function_details/actions'
import { pageChanged } from '../../../../../data/redux/page_details/actions'
import { getIsMobile } from '../../../../../data/redux/page_details/selectors'

import { APP_PAGES } from '../../../../../data/config/constants'
import { uniqueId, showMessage } from '../../../../../data/config/utils'

import TableCellAction from '../../../components/tablecellaction'
import CommonForm from '../../../../../components/commonform'
import ErrorBoundary from '../../../../../components/errorboundary'

class BrandFunctions extends React.Component {
  state = {
    create_bf: {},
    modal_data: {
      title: '',
      show_create_bf: false
    }
  }

  columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      className: "ori-font-bold ori-capitalize-first",
    },
    {
      title: 'Description',
      dataIndex: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      className: "ori-font-bold",
      render: isActive => (isActive ? <span className="ori-font-green">ACTIVE</span> : <span className="ori-font-danger">INACTIVE</span>)
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      render: (text, record) => <TableCellAction show_edit handleEditClick={this.handleEditBrandFunction.bind(this, record)} />
    }
  ]

  componentDidMount() {
    const { actions, bf_table_current_page } = this.props
    actions.pageChanged(APP_PAGES.BRAND_FUNCTIONS, APP_PAGES.BOT_BUILDER)
    actions.getAllBrandFunctions({ skip: (bf_table_current_page - 1) * 20, limit: 20 })
  }

  onPaginationChange = (page, page_size) => {
    const { actions } = this.props
    const payload = {
      skip: (page - 1) * page_size,
      limit: page_size
    }
    actions.getAllBrandFunctions(payload, { bf_table_current_page: page })
  }

  handleEditBrandFunction = bf => {
    const { history, match } = this.props
    if (bf && bf._id)
      history.push(`${match.path}/${bf._id}`)
    else
      showMessage('error', 'Brand Function Id is missing.')
  }

  showCreateBFModal = () => {
    this.setState({
      modal_data: {
        title: "Create Brand Function",
        show_create_bf: true,
      }
    })
  }

  closeModal = () => {
    this.setState({
      create_bf: {},
      modal_data: {
        title: "",
        show_create_bf: false,
      }
    })
  }

  onChangeCreateBF = event => {
    this.setState({
      create_bf: {
        ...this.state.create_bf,
        [event.target.name]: event.target.value
      }
    })
  }

  handleCreateBF = () => {
    const { actions } = this.props
    const { create_bf } = this.state
    if (create_bf.name) {
      const trimed_bf_name = create_bf.name.replace(/ /g, "")
      if (trimed_bf_name.length === create_bf.name.trim().length)
        actions.createBrandFunction(create_bf, this.closeModal)
      else
        showMessage('warning', 'brand function name should not contain any spaces.')
    } else
      showMessage('warning', 'brand function name is required.')
  }

  renderBrandFunctionCommonForm = () => {
    const { modal_data, create_bf } = this.state
    const { bf_loading } = this.props
    if (modal_data.show_create_bf) {
      const first_input_props = {
        title: "Name",
        placeholder: "Enter Brand Function Name",
        name: "name",
        value: create_bf.name,
        autoFocus: true,
        onChange: this.onChangeCreateBF,
      }
      const first_textarea_props = {
        title: "Description",
        placeholder: "Write description...",
        value: create_bf.description,
        name: "description",
        onChange: this.onChangeCreateBF,
      }
      const modal_footer_props = {
        button_ok_text: bf_loading ? "Creating" : "Create",
        loading: bf_loading,
        handleCancelClick: this.closeModal,
        handleOkClick: this.handleCreateBF
      }
      return (
        <ErrorBoundary onErrorCallback={this.closeModal}>
          <CommonForm
            first_input_props={first_input_props}
            first_textarea_props={first_textarea_props}
            modal_footer_props={modal_footer_props}
            show_first_input
            show_first_textarea
          />
        </ErrorBoundary>
      );
    }
  }

  render() {
    const { is_mobile, brand_functions, bf_loading, total_bf_count, bf_table_current_page } = this.props
    const { modal_data } = this.state
    return (
      <div className="ori-lr-pad-10">
        <div className="ori-t-pad-15 ori-flex-row ori-flex-jsb ori-flex-wrap ori-b-border-default ori-b-mrgn-5">
          <p className="ori-b-mrgn-15">Brand Functions</p>
          <Button
            size='small'
            type='primary'
            className='ori-font-xs ori-b-mrgn-15'
            onClick={this.showCreateBFModal}
          >
            + Add New
          </Button>
        </div>
        <Table
          className="ori-card-row-table"
          rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light"
          scroll={{ x: 600 }}
          size={is_mobile ? "small" : "middle"}
          rowKey={uniqueId}
          columns={this.columns}
          dataSource={brand_functions}
          loading={bf_loading}
          pagination={false}
        />
        <div className="ori-t-pad-10 ori-b-pad-20 ori-lr-pad-10 ori-flex-row ori-flex-jfe">
          <Pagination
            size="small"
            total={total_bf_count}
            current={bf_table_current_page}
            pageSize={20}
            onChange={this.onPaginationChange}
          />
        </div>
        <Modal
          className="ori-modal-primary"
          title={modal_data.title}
          footer={null}
          visible={modal_data.show_create_bf}
          maskClosable={false}
          onCancel={this.closeModal}
        >
          {this.renderBrandFunctionCommonForm()}
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    is_mobile: getIsMobile(state),
    brand_functions: state.brand_functions_details.brand_functions,
    total_bf_count: state.brand_functions_details.total_bf_count,
    bf_table_current_page: state.brand_functions_details.bf_table_current_page,
    bf_loading: state.brand_functions_details.bf_loading,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        pageChanged,
        getAllBrandFunctions,
        createBrandFunction
      },
      dispatch
    )
  }
}

BrandFunctions.propTypes = {
  actions: PropTypes.object,
  is_mobile: PropTypes.bool,
  brand_functions: PropTypes.array,
  total_bf_count: PropTypes.number,
  bf_table_current_page: PropTypes.number,
  bf_loading: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object
}

BrandFunctions.defaultProps = {
  is_mobile: false
}

export default connect(mapStateToProps, mapDispatchToProps)(BrandFunctions)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/brandfunctions/index.js